import { render, staticRenderFns } from "./TrackerKanban.vue?vue&type=template&id=095c420c&scoped=true"
import script from "./TrackerKanban.js?vue&type=script&lang=js&external"
export * from "./TrackerKanban.js?vue&type=script&lang=js&external"
import style0 from "./TrackerKanban.vue?vue&type=style&index=0&id=095c420c&prod&scoped=true&lang=css"
import style1 from "./TrackerKanban.vue?vue&type=style&index=1&id=095c420c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c420c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
import VLoader from '@/agilis/wrappers/VLoader/VLoader.vue'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VIcon,VLazy,VLoader})
